import { type ReactNode } from 'react'
import { type Generation } from '../lib/api'
import GenerationCard from './GenerationCard'

interface GenerationGridProps {
  generations: Generation[]
  onCardClick?: (generation: Generation) => void
  onDelete?: (id: string) => void
  onReuse?: (generation: Generation) => void
  children?: ReactNode
}

export default function GenerationGrid({
  generations,
  onCardClick,
  onDelete,
  onReuse,
  children,
}: GenerationGridProps) {
  if (generations.length === 0 && !children) {
    return (
      <div className="flex flex-col items-center justify-center py-24 text-center">
        <div className="w-16 h-16 mb-4 rounded-2xl bg-bg-card border border-border flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            className="text-text-muted"
          >
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
            <circle cx="8.5" cy="8.5" r="1.5" />
            <polyline points="21 15 16 10 5 21" />
          </svg>
        </div>
        <h3 className="text-lg font-medium text-text-primary mb-1">
          No generations yet
        </h3>
        <p className="text-sm text-text-muted max-w-sm">
          Enter a prompt below to create your first image or video with AI.
        </p>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {children}
      {generations.map((generation) => (
        <GenerationCard
          key={generation.id}
          generation={generation}
          onClick={onCardClick ?? (() => {})}
          onDelete={onDelete ?? (() => {})}
          onReuse={onReuse}
        />
      ))}
    </div>
  )
}
